import { Stepper } from '@/components/ui'

const QUALITY_LABELS: Record<number, string> = {
  1: 'Slecht',
  2: 'Matig',
  3: 'Redelijk',
  4: 'Goed',
  5: 'Uitstekend',
}

type SleepSectionProps = {
  sleepHours: number
  onSleepHoursChange: (value: number) => void
  sleepQuality: number
  onSleepQualityChange: (value: number) => void
  disabled?: boolean
}

/** Sleep hours stepper (0.5 increments) + sleep quality 1–5 with text labels. */
export function SleepSection({
  sleepHours,
  onSleepHoursChange,
  sleepQuality,
  onSleepQualityChange,
  disabled = false,
}: SleepSectionProps) {
  return (
    <>
      <Stepper
        label="Uren slaap"
        value={sleepHours}
        onChange={onSleepHoursChange}
        min={0}
        max={16}
        step={0.5}
        unit="uur"
      />
      <div className="health-section">
        <p className="health-section-title" id="sleep-quality-label">
          Slaapkwaliteit
        </p>
        <div className="quality-row" role="group" aria-labelledby="sleep-quality-label">
          {[1, 2, 3, 4, 5].map((score) => (
            <button
              key={score}
              type="button"
              className="quality-btn"
              aria-pressed={score === sleepQuality}
              aria-label={`Slaapkwaliteit ${score} van 5: ${QUALITY_LABELS[score]}`}
              disabled={disabled}
              onClick={() => onSleepQualityChange(score)}
            >
              {score}
            </button>
          ))}
        </div>
        <p className="quality-caption" aria-live="polite">
          {sleepQuality} van 5 — {QUALITY_LABELS[sleepQuality]}
        </p>
      </div>
    </>
  )
}
